import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Ambiente } from '../types/Ambiente.type';

@Injectable({
  providedIn: 'root'
})
export class AmbienteService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getMeusAmbientes(){
    return this.httpClient.get<Ambiente[]>(`${this.configService.getApiUrl()}/ambiente/meusambientes`);
  }

  put(ambiente: Ambiente){

    return this.httpClient.put(`${this.configService.getApiUrl()}/ambiente`, ambiente);

  }

  post(ambiente: Ambiente){
    return this.httpClient.post(`${this.configService.getApiUrl()}/ambiente`, ambiente);
  }
}
